import { render, staticRenderFns } from "./DianPuXiaoFeiPangHang.vue?vue&type=template&id=2deb3a37&scoped=true&"
import script from "./DianPuXiaoFeiPangHang.vue?vue&type=script&lang=js&"
export * from "./DianPuXiaoFeiPangHang.vue?vue&type=script&lang=js&"
import style0 from "./DianPuXiaoFeiPangHang.vue?vue&type=style&index=0&id=2deb3a37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deb3a37",
  null
  
)

export default component.exports